<template>
<svg
    :class="bem([size, name, { spin }])"
><use :xlink:href="'#' + name"/></svg>

</template>
<script>
import { bemMixin } from '../utils';
export default {
  name: 'g-icon',
  mixins: [bemMixin],
  props: {
    // 图标名
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    spin: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style>
.g-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
  font-size: 24px;
}
.g-icon--small {
  font-size: 12px;
}
.g-icon--medium {
  font-size: 18px;
}
.g-icon--big {
  font-size: 22px;
}
.g-icon--large {
  font-size: 32px;
}
.g-icon--huge {
  font-size: 42px;
}
.g-icon--gigantic {
  font-size: 64px;
}
.g-icon--spin {
  animation: icon-rotation 1s infinite linear;
}
@keyframes icon-rotation {
  100% {
    transform: rotate(360deg);
  }
}

</style>
